import {observable, action, toJS, computed} from 'mobx';

import {message} from 'antd';
import {BaseStore} from './base';
import * as api from  '../helpers/api';
import {handleRequestError} from '../helpers/errors';
import {getUser, onUserChange, setUser} from '../helpers/session';
import {saveSettings} from '../helpers/api';

export class LoginStore extends BaseStore {
  @observable isLoginInProcess = false;
  @observable user = getUser();
  @observable updatingUserState = false;
  @observable isUserUpToDate = false;
  @observable settings = {
    ourTable: { fields: {} },
    reqTable: { fields: {} }
  };

  constructor(root) {
    super(root);

    onUserChange((newUser) => {
      this.onUserChanged(newUser);
    });
  }

  @action onUserChanged(newUser) {
    this.user = newUser;
  }

  @action async loadUserState() {
    if(!this.user) {
      return setUser(null);
    }

    if(this.isUserUpToDate || this.updatingUserState) {
      return true;
    }

    this.updatingUserState = true;
    const state = await api.userState();
    if(state) {
      console.log(state, this.user);
      console.log(state.user.settings);
      const settings = {
        our: JSON.parse(state.user.settings.our),
        req: JSON.parse(state.user.settings.req),
        arc: JSON.parse(state.user.settings.arc),
        lk: JSON.parse(state.user.settings.lk)
      };

      console.log('settings', settings);

      this.settings = settings;

      setUser({
        ...toJS(this.user),
        user: state.user
      });
    }
    this.updatingUserState = false;
    this.isUserUpToDate = true;
  }

  @action async sign(data) {
    console.log('sign with', data);
    this.isLoginInProcess = true;
    const res = await api.sign(data).noHandleError();
    this.isLoginInProcess = false;

    const err = res.error;
    if(err) {
      if (err.is('user_exists')) {
        message.error('Пользователь с таким номером уже зарегистрирован');
      } else {
        handleRequestError(err)
      }
    } else {
      this._setUser(res.data);
    }
  }

  @action async signConfirm(code) {
    console.log('sign confirm with', code);
    this.isLoginInProcess = true;
    const res = await api.signConfirm(code).noHandleError();
    this.isLoginInProcess = false;

    const err = res.error;
    if(err) {
      if (err.is('wrong_confirmation_code')) {
        message.error('Неверный код подтверждения');
      } else {
        handleRequestError(err);
      }
    } else {
      const user = this.user;
      user.user.status = 'active';
      setUser(user);
    }
  }

  @action async signResend() {
    const res = await api.signResend().noHandleError();
    const err = res.error;

    if (err) {
      if (err.is('too_many_sms')) {
        message.error('Вы превысили лимит на количество переотправлений смс. Повторите попытку через 30 мин');
      } else {
        handleRequestError(err);
      }

      return false;
    }

    return true;
  }

  @action async login(email, password) {
    console.log('login with', email, password);
    this.isLoginInProcess = true;
    const res = await api.login(email, password).noHandleError();
    this.isLoginInProcess = false;

    const err = res.error;
    if(err) {
      if(err.is('wrong_username_or_password')) {
        message.error('Неверный логин или пароль!');
      } else {
        handleRequestError(err)
      }
    } else {
      this._setUser(res.data);
    }
  }

  _setUser(data) {
    console.log('_setUser');
    this.settings = {
      our: JSON.parse(data.user.settings.our),
      req: JSON.parse(data.user.settings.req),
      arc: JSON.parse(data.user.settings.arc),
      lk: data.user.settings.lk ? JSON.parse(data.user.settings.lk) : { fields: {} }
    };

    setUser(data);
  }

  @action async changePassword(password, newPassword) {
    const res = await api.changePassword(password, newPassword).noHandleError();
    const err = res.error;
    if(err) {
      if(err.is('wrong_username_or_password')) {
        message.error('Неверный пароль!');
      } else {
        handleRequestError(err)
      }
    } else {
      const user = getUser();
      user.accessToken = res.data.accessToken;
      setUser(user);
      message.success('Пароль успешно изменен');
    }
  }

  @action extendTableFieldSettings(page, key, value) {
    const next = toJS(this.settings[page].fields);
    next[key] = value;

    if (!this.settings[page]) {
      this.settings[page] = { fields: {}};
    }

    this.settings[page].fields = next;
    //this won't re-render components
  }

  @action async saveSettings() {
    const hide = message.loading('Сохранение изменений..', 0);
    const settings = toJS(this.settings);
    settings.req = JSON.stringify(settings.req);
    settings.our = JSON.stringify(settings.our);
    settings.arc = JSON.stringify(settings.arc);
    settings.lk = JSON.stringify(settings.lk);

    console.log(JSON.stringify(settings));

    const res = await saveSettings(settings);
    hide();
    if(res) {
      message.success('Сохранено!');
    }
  }


  @action logout() {
    setUser(null);
    location.reload();
  }

  @computed get isAdmin() {
    return this.user && this.user.user && this.user.user.type === 'admin';
  }

}



// WEBPACK FOOTER //
// ./src/stores/login-store.js